import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, Tab, Nav } from 'react-bootstrap';
import pkgImg from '../../../images/task/pic4.jpg';

import Assigned from './TourPackages/AssignedPkg';
import { fetchEmployeeServices } from '../../services/serviceServices';

const PackageList = () => {
  const [selectBtn, setSelectBtn] = useState('Newest');
  const [data, setData] = useState(document.querySelectorAll('#room_wrapper tbody tr'));
  const [packagesList, setPackagesList] = useState(packageList || []);

  const [openDropdownId, setOpenDropdownId] = useState(null);

  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [limit] = useState(5); // Number of services per page
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);

  useEffect(() => {
    loadServices();
  }, [page, selectBtn]);

  const loadServices = async () => {
    try {
      setLoading(true);
      const sortBy = selectBtn.toLowerCase(); // Convert to API format
      const response = await fetchEmployeeServices(page, limit, sortBy);
      setPackagesList(response?.services || []);
      setTotalPages(response?.totalPages || 1);
      setTotalEntries(response?.totalServices);
    } catch (error) {
      console.error('Error fetching services:', error);
    } finally {
      setLoading(false);
    }
  };

  const toggleDropdown = (id) => {
    setOpenDropdownId((prevId) => (prevId === id ? null : id));
  };
  const sort = 10;
  const activePag = useRef(0);
  const [test, settest] = useState(0);

  // Active data
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove('d-none');
      } else {
        data[i].classList.add('d-none');
      }
    }
  };
  // use effect
  useEffect(() => {
    setData(document.querySelectorAll('#room_wrapper tbody tr'));
    //chackboxFun();
  }, [test]);

  // Active pagginarion
  activePag.current === 0 && chageData(0, sort);
  // paggination
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);

  // Active paggination & chage data
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
    settest(i);
  };

  const chackbox = document.querySelectorAll('.sorting_7 input');
  const motherChackBox = document.querySelector('.sorting_asc_7 input');
  // console.log(document.querySelectorAll(".sorting_1 input")[0].checked);
  const chackboxFun = (type) => {
    for (let i = 0; i < chackbox.length; i++) {
      const element = chackbox[i];
      if (type === 'all') {
        if (motherChackBox.checked) {
          element.checked = true;
        } else {
          element.checked = false;
        }
      } else {
        if (!element.checked) {
          motherChackBox.checked = false;
          break;
        } else {
          motherChackBox.checked = true;
        }
      }
    }
  };

  return (
    <>
      <Tab.Container defaultActiveKey="All">
        <div className="mt-4 d-flex justify-content-between align-items-center flex-wrap">
          <div className="card-action coin-tabs mb-2">
            <Nav as="ul" className="nav nav-tabs" role="tablist">
              <Nav.Item as="li" className="nav-item">
                <Nav.Link className="nav-link" eventKey="All">
                  Services
                </Nav.Link>
              </Nav.Item>
              {/* <Nav.Item as="li" className="nav-item">
                <Nav.Link className="nav-link" eventKey="Assigned">
                  Assigned To Me
                </Nav.Link>
              </Nav.Item> */}
            </Nav>
          </div>
          <div className="d-flex align-items-center mb-2">
            {/* <Link
              to={"#"}
              onClick={handleAddPackage}
              className="btn btn-secondary"
            >
              + New Package
            </Link> */}
            <div className="newest ms-3">
              <Dropdown>
                <Dropdown.Toggle as="div" className=" btn-select-drop default-select btn i-false">
                  {selectBtn} <i className="fas fa-angle-down ms-2 "></i>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setSelectBtn('Oldest')} eventKey="All">
                    Oldest
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => setSelectBtn('Newest')} eventKey="All">
                    Newest
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <Tab.Content>
                  <Tab.Pane eventKey="All">
                    <div className="table-responsive">
                      <div id="room_wrapper" className="dataTables_wrapper no-footer">
                        <table className="table card-table display mb-4 dataTablesCard booking-table room-list-tbl dataTable no-footer">
                          <thead>
                            <tr role="row">
                              <th>Service Name</th>
                              <th>Location</th>
                              <th>Price</th>
                              <th>Type</th>
                              <th>Availability</th>
                              <th>Assigned to Me</th>
                              {/* <th className="bg-none"></th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {loading ? (
                              <tr>
                                <td colSpan="7" className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            ) : packagesList.length > 0 ? (
                              packagesList.map((pkg) => (
                                <tr role="row" className="odd" key={pkg._id}>
                                  <td>
                                    <div className="package-list-bx d-flex gap-x-3 align-items-center">
                                      <img
                                        src={pkg.imageUrl || pkgImg}
                                        alt={pkg.name}
                                        width={100}
                                        height={80}
                                        className="my-auto max-h-[80px] rounded-lg"
                                      />
                                      <Link to={`/package-details/${pkg._id}`}>
                                        <span className="text-lg text-secondary d-block">{pkg.name}</span>
                                      </Link>
                                    </div>
                                  </td>
                                  <td>
                                    <span className="fs-16 font-w500 text-nowrap">{pkg.location}</span>
                                  </td>
                                  <td>
                                    <span className="fs-16 font-w500">£{pkg.price}</span>
                                  </td>
                                  <td>
                                    <span className="fs-16 font-w500">{pkg.type}</span>
                                  </td>
                                  <td>
                                    <div className="position-relative">
                                      <button
                                        className="btn gradient_one btn-sm"
                                        onClick={() => toggleDropdown(pkg._id)}
                                      >
                                        Check Availability
                                      </button>
                                      {openDropdownId === pkg._id && (
                                        <div
                                          className="dropdown-menu show position-absolute mt-1"
                                          style={{
                                            zIndex: 1050,
                                            minWidth: 'auto',
                                            padding: '0.5rem',
                                            backgroundColor: '#fff',
                                            border: '1px solid #ddd',
                                            borderRadius: '0.25rem',
                                            boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.15)',
                                          }}
                                        >
                                          {pkg?.availableDates?.length > 0 ? (
                                            pkg?.availableDates?.map((available, index) => (
                                              <div
                                                className="dropdown-item"
                                                style={{
                                                  padding: '0.25rem 0.5rem',
                                                  fontSize: '0.875rem',
                                                  cursor: 'pointer',
                                                }}
                                                key={index}
                                              >
                                                {new Date(available).toLocaleDateString()}
                                              </div>
                                            ))
                                          ) : (
                                            <div className="dropdown-item">No dates available</div>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </td>
                                  <td>
                                    <span className="fs-16 font-w500">
                                      {pkg.assignedCount ? pkg.assignedCount : 'Not assigned!'}
                                    </span>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="7" className="text-center">
                                  No services found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        {packageList.length > 0 && (
                          <div className="d-sm-flex text-center justify-content-between align-items-center mt-3 mb-3">
                            <div className="dataTables_info">
                              Showing {(page - 1) * limit + 1} to {Math.min(page * limit, totalEntries)} of{' '}
                              {totalEntries} entries
                            </div>
                            <div className="dataTables_paginate paging_simple_numbers mb-0">
                              <Link
                                className={`paginate_button previous ${page === 1 ? 'disabled' : ''}`}
                                onClick={() => page > 1 && setPage(page - 1)}
                              >
                                <i className="fa fa-angle-double-left"></i> Previous
                              </Link>
                              <span>
                                {[...Array(totalPages)].map((_, i) => (
                                  <Link
                                    key={i}
                                    className={`paginate_button ${page === i + 1 ? 'current' : ''}`}
                                    onClick={() => setPage(i + 1)}
                                  >
                                    {i + 1}
                                  </Link>
                                ))}
                              </span>
                              <Link
                                className={`paginate_button next ${page === totalPages ? 'disabled' : ''}`}
                                onClick={() => page < totalPages && setPage(page + 1)}
                              >
                                Next <i className="fa fa-angle-double-right"></i>
                              </Link>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </div>
        </div>
      </Tab.Container>
    </>
  );
};

const packageList = [
  {
    id: 'DJLSF23092',
    name: 'Hotel',
    imageUrl: '',
    location: 'Dubai',
    price: 145,
    duration: '5 Days',
    availability: [new Date('2024, 06, 12'), new Date('2024, 07, 12'), new Date('2024, 08, 12')],
    assignedToMe: 12,
  },
  {
    id: 'DJLSFsvss2',
    name: 'Flight Booking',
    imageUrl:
      'https://media.istockphoto.com/id/155380716/photo/commercial-jet-flying-over-clouds.jpg?s=1024x1024&w=is&k=20&c=Vq45uT-uzvp1_R0RwUbSEVN6IkQwkvJKLPiQkRxWj0U=',
    location: 'Dubai',
    price: 145,
    duration: '5 Days',
    availability: [new Date('2024, 06, 12'), new Date('2024, 07, 12'), new Date('2024, 08, 12')],
    assignedToMe: 12,
  },
  {
    id: 'DJLS2333092',
    name: 'Admission Enquiries',
    imageUrl:
      'https://www.shutterstock.com/shutterstock/photos/1918702652/display_1500/stock-photo-black-graduation-hat-with-diploma-and-book-1918702652.jpg',
    location: '',
    price: 145,
    duration: '5 Days',
    availability: [new Date('2024, 06, 12'), new Date('2024, 07, 12'), new Date('2024, 08, 12')],
    assignedToMe: 12,
  },
  {
    id: 'D21F23092',
    name: 'Dubai Tour Package',
    imageUrl:
      'https://images.unsplash.com/photo-1518684079-3c830dcef090?q=80&w=1374&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    location: 'Dubai',
    price: 145,
    duration: '5 Days',
    availability: [new Date('2024, 06, 12'), new Date('2024, 07, 12'), new Date('2024, 08, 12')],
    assignedToMe: 12,
  },
  {
    id: 'DJLS42292',
    name: 'Thailand Tour Package',
    imageUrl:
      'https://images.unsplash.com/photo-1519451241324-20b4ea2c4220?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    location: 'Thailand',
    price: 145,
    duration: '5 Days',
    availability: [new Date('2024, 06, 12'), new Date('2024, 07, 12'), new Date('2024, 08, 12')],
    assignedToMe: 12,
  },
  {
    id: '232323092',
    name: 'Malaysia Tour Package',
    imageUrl:
      'https://images.unsplash.com/photo-1506320775314-84c60bff00ff?q=80&w=1374&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    location: 'Malaysia',
    price: 145,
    duration: '5 Days',
    availability: [new Date('2024, 06, 12'), new Date('2024, 07, 12'), new Date('2024, 08, 12')],
    assignedToMe: 12,
  },
];

export default PackageList;
